import { Breadcrumb } from '@sentry/react';

const fileExtentionsPreventBreadcrumbs = ['.png', '.svg'];

export const filterBreadcrumbs = (breadcrumb: Breadcrumb) => {
    const url = breadcrumb?.data?.url;

    return fileExtentionsPreventBreadcrumbs.some((extention) => url?.endsWith(extention)) ? null : breadcrumb;
};